import React from 'react';
import { IoPlayCircle, IoCloudDownloadOutline } from 'react-icons/io5';
import iniciativaVideoImg from '../../../assets/img/2026/iniciativa_video.png';

interface ElogioPorTipo {
  elogio: string;
  quantidade: number;
}

interface IniciativaHeroProps {
  imagem: string;
  titulo: string;
  categoria: string;
  corCategoria: string;
  documentacao?: string;
  videoUrl?: string;
  originalVideoUrl?: string;
  totalElogios: number;
  totalCompartilhamentos: number;
  totalFavoritos: number;
  elogiosPorTipo: ElogioPorTipo[];
  children?: React.ReactNode;
}

export const IniciativaHero: React.FC<IniciativaHeroProps> = ({
  imagem,
  titulo,
  categoria,
  corCategoria,
  documentacao,
  videoUrl,
  originalVideoUrl,
  totalElogios,
  totalCompartilhamentos,
  totalFavoritos,
  elogiosPorTipo,
  children,
}) => {
  const temFeedback =
    elogiosPorTipo.length > 0 || totalCompartilhamentos > 0 || totalFavoritos > 0;

  return (
    <div className="flex flex-col gap-4">
      {/* Imagem/vídeo */}
      {videoUrl ? (
        <a
          href={originalVideoUrl || videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block relative rounded-xl overflow-hidden"
        >
          <img
            src={iniciativaVideoImg}
            alt="Clique para assistir ao vídeo da iniciativa"
            className="w-full object-cover block"
          />
        </a>
      ) : (
        <div className="relative rounded-xl overflow-hidden bg-black">
          <img src={imagem} alt={titulo} className="w-full h-[280px] object-cover block" />
          <button
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-transparent border-0 text-white/80 cursor-pointer hover:text-white transition-colors"
            aria-label="Reproduzir vídeo"
          >
            <IoPlayCircle size={56} />
          </button>
        </div>
      )}

      {/* Documentação */}
      {documentacao && (
        <div className="flex items-center justify-between gap-3 p-3 bg-blue-50 rounded-lg">
          <p className="text-sm text-gray-600 m-0">
            Documentação complementar da realização
          </p>
          <a
            href={documentacao}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 bg-[#1e3a5f] text-white rounded-md px-3.5 py-1.5 text-xs font-bold no-underline whitespace-nowrap hover:bg-[#27518a] transition-colors"
          >
            <IoCloudDownloadOutline size={20} />
            <span>DOWNLOAD</span>
          </a>
        </div>
      )}

      {children}

      {/* Feedback */}
      {temFeedback && (
        <div className="bg-white border border-gray-200 rounded-xl p-4">
          <h3 className="text-sm font-bold text-gray-800 mt-0 mb-3">Feedback na iniciativa:</h3>
          <div className="flex flex-col gap-2">
            {elogiosPorTipo.map((item, index) => (
              <div key={index} className="flex items-center gap-2.5">
                <span className="text-lg font-bold text-[#1e3a5f] min-w-[28px]">
                  {String(item.quantidade).padStart(2, '0')}
                </span>
                <span className="text-sm text-gray-500">{item.elogio}</span>
              </div>
            ))}
            {totalCompartilhamentos > 0 && (
              <div className="flex items-center gap-2.5">
                <span className="text-lg font-bold text-[#1e3a5f] min-w-[28px]">
                  {String(totalCompartilhamentos).padStart(2, '0')}
                </span>
                <span className="text-sm text-gray-500">Compartilhamentos</span>
              </div>
            )}
            {totalFavoritos > 0 && (
              <div className="flex items-center gap-2.5">
                <span className="text-lg font-bold text-[#1e3a5f] min-w-[28px]">
                  {String(totalFavoritos).padStart(2, '0')}
                </span>
                <span className="text-sm text-gray-500">Salvos nas favoritas</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
